import type { PaginatedResult } from '../../../data/type';
import { getRhinoErrorContext, isRhinoError } from '../../../error';
import { ErrorCode } from '../../errorCodes';

type ErrorCodeType = (typeof ErrorCode)[keyof typeof ErrorCode];

const errorCodesToHandle: ErrorCodeType[] = [
  ErrorCode.ChannelDoesNotExist,
  ErrorCode.CollectionNotExist,
  ErrorCode.ExternalChannelNotExist,
  ErrorCode.NoExternalChannelToUpdate,
  ErrorCode.ObjectNotExist,
];

export async function withCollectionFallback<T>(
  request: () => Promise<PaginatedResult<T>>,
): Promise<PaginatedResult<T>> {
  try {
    return await request();
  } catch (error) {
    if (!isRhinoError(error)) {
      throw error;
    }

    const context = getRhinoErrorContext(error);

    if (!context || !context.code) {
      throw error;
    }

    const code = context.code as ErrorCodeType;

    if (errorCodesToHandle.includes(code)) {
      return {
        objects: [],
        totalCount: 0,
      };
    }

    throw error;
  }
}
